import React, { useEffect, useState } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { reportService } from 'services';
import { doAmountFormat, doDateFormat } from 'utils';
import { _Object } from 'utils/interfaces';
import ReportSkeleton from './skelton';
import moment from 'moment';

const TopBuyers = (props: _Object) => {
  const { dateRange } = props

  const [topBuyers, setTopBuyers] = useState<_Object>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    reportService.getTopBuyers(dateRange.date1).then((data: _Object) => {
      setLoading(false)
      if (data?.items?.length > 0) {
        setTopBuyers(data)
      } else {
        setTopBuyers([])
      }
    })
  }, [dateRange.date1.start_date])

  const series1 = topBuyers?.items?.length > 0
    ? topBuyers.items.map((item: _Object) => parseFloat(item.total.toFixed(2)))
    : [];

  const options = {
    chart: {
      type: 'bar',
    },
    title: {
      text: 'Top buyers',
      align: 'left',
      margin: 35
    },
    subtitle: {
      text: doAmountFormat(topBuyers?.total ? topBuyers?.total : 0),
      align: 'left',
    },
    xAxis: {
      categories: topBuyers?.items?.map((item: _Object) => item.name
        ? `${item.name.substring(0, 10)}\n${item.mobile_number}`
        : item.mobile_number),
      gridLineWidth: 1,
      lineWidth: 0,
      labels: {
        useHTML: true,
        formatter: function (this: any): string {
          const value = String(this.value); // Ensure value is a string
          const parts = value.split('\n');
          return `<div>${parts[0] || ''}</div><div>${parts[1] || ''}</div>`;
        },
      }
    },
    yAxis: {
      min: 0,
      labels: {
        overflow: 'justify',
        enabled: false,
      },
      title: {
        text: null,
      },
      gridLineWidth: 0,
      showEmpty: false,
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      formatter: function (this: Highcharts.TooltipFormatterContextObject): string {
        const nameAndPhone = String(this.points?.[0]?.x); // Ensure nameAndPhone is a string
        const phoneNumber = (nameAndPhone.split('\n')[1] || '').trim();
        const totalAmount = this.points?.[0]?.y;
        const buyerData = topBuyers.items.find((item: _Object) => item.phone_number === phoneNumber);

        return `<br />Orders count: ${buyerData?.count || 0}<br /><b>Orders total: ${doAmountFormat(totalAmount)}</b>`;
      },
      style: {
        fontSize: '10px',
      },
    },
    plotOptions: {
      bar: {
        color: '#2003ff',
        borderRadius: 2,
        dataLabels: {
          enabled: true,
          formatter: function (this: any): string {
            return doAmountFormat(this.y as number); // Format the label values
          },
          inside: false,
        },
        groupPadding: 0.2,
      },
    },
    series: [
      {
        name: `${moment(dateRange.date1.start_date).format('DD MMM')} - ${doDateFormat(dateRange.date1.end_date)}`,
        data: series1,
        color: '#2003ff',
      }
    ],
  };


  return (
    <>
      {loading ? <ReportSkeleton />
        :
        <HighchartsReact highcharts={Highcharts} options={options} />
      }
    </>
  );
};

export default TopBuyers;
